import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';

import Order from '../../../records/Order';
import { translate as t } from '../../../lib/I18n';
import useChangeovers from '../../../hooks/useChangeovers';
import OnEnterTrigger from '../../general/OnEnterTrigger';
import Icon from '../../general/Icon';
import classnames from 'classnames';
import Price from '../../general/Price';

const Changeovers = ({ order }) => {
    const { changeovers } = useChangeovers(order);
    const [open, setOpen] = useState(false);

    const toggleOpen = useCallback(() => {
        setOpen(!open);
    }, [open]);

    const dropDownClassNames = classnames('hidden-print text-secondary', {
        'otrl-rotate-180': open,
    });

    if (changeovers.isEmpty()) {
        return null;
    }

    const changeover = changeovers.first();

    return (
        <div className="box--light box--rounded bg--white margin-bottom--sm margin-top--sm">
            <OnEnterTrigger element="span" onClick={toggleOpen}>
                <Row className="no-margin box--clickable padding--vert-md">
                    <Col xs={10}>
                        <h3 className="text-weight--bold margin-bottom--xs">{t('account.orders.changeover.originalSeasonTicket')}</h3>
                        <div className="like-table fare-stations" key={`changeover-${changeover.id}`}>
                            <div className="table-row">
                                <div className="table-cell text-weight--normal">{changeover.fromOrigin.name}</div>
                                <div className="table-cell direction text-center">
                                    <Icon icon="arrowback" className="otrl-rotate-180" />
                                </div>
                                <div className="table-cell text-weight--normal">{changeover.fromDestination.name}</div>
                            </div>
                        </div>
                    </Col>
                    <Col xs={2} className="text-right">
                        <div className="padding--vert-md">
                            <Icon icon="dropdown" className={dropDownClassNames} />
                        </div>
                    </Col>
                </Row>
            </OnEnterTrigger>
            {open ? (
                <div className="padding--horiz-md padding-bottom--sm">
                    <div className="padding--vert-md border--top">
                        <Row className="text-weight--normal text-secondary">
                            <Col xs={8}>{t('account.orders.changeover.originalSeasonTicket')}:</Col>
                            <Col xs={4} className="text-right"><Price price={changeover.oldPrice} /></Col>
                        </Row>
                        <Row className="text-weight--normal text-secondary">
                            <Col xs={8}>{t('account.orders.changeover.newSeasonTicket')}:</Col>
                            <Col xs={4} className="text-right"><Price price={changeover.newPrice} /></Col>
                        </Row>
                    </div>
                    <div className="padding--vert-md border--top">
                        <Row className="text-weight--normal text-secondary">
                            <Col xs={8}>{t('account.orders.changeover.daysRemaining')}:</Col>
                            <Col xs={4} className="text-right">{changeover.daysRemaining}</Col>
                        </Row>
                    </div>
                    <div className="padding--vert-md border--top">
                        <Row className="text-weight--normal text-secondary">
                            <Col xs={8}>{t('account.orders.changeover.creditRemaining')}:</Col>
                            <Col xs={4} className="text-right"><Price price={changeover.credit} /></Col>
                        </Row>
                        <Row className="text-weight--normal text-secondary">
                            <Col xs={8}>{t('account.orders.changeover.amountDue')}:</Col>
                            <Col xs={4} className="text-right"><Price price={changeover.amountDue} /></Col>
                        </Row>
                    </div>
                    <div className="padding-top--sm border--top">
                        <Row className="text-md text-weight--bold text-primary">
                            <Col xs={8}>{t('account.orders.changeover.totalAmount')}:</Col>
                            <Col xs={4} className="text-right"><Price price={changeover.oldPrice + changeover.difference} /></Col>
                        </Row>
                    </div>

                </div>
            ) : null}
        </div>
    );
};

Changeovers.propTypes = {
    order: PropTypes.instanceOf(Order).isRequired,
};

Changeovers.defaultProps = {};

export default Changeovers;
